/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import firebase from "../../../config/firebase";
import {
  Card,
  CardBody,
  Col,
  Table,
  Badge,
  Collapse,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Spinner
} from "reactstrap";
import ReactHTMLParser from "react-html-parser";
// import { getJobWithId } from "../../../redux/middlewares/Jobs/get_jobs";
import { withRouter } from "react-router-dom";
// import { JOB_PATH } from "../../../URLs";
// import EditJob from "../../Edit/components/EditJob";
// import "./viewJob.style.scss";
// import {
//   getCompanyWithId,
//   getCurrentCompany
// } from "../../../redux/middlewares/Company/getCompany";
import { toast } from "react-toastify";
import ResourcePreview from "./ResourcePreview";

// const fromMiliSecondsToDate = seconds => new Date(seconds).toLocaleDateString();
const resourceRef = firebase.firestore().collection("resources");

const JobDetails = props => {
  const [resource, setResource] = useState(undefined);
  const [company, setCompany] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isEditOpen, setEditOpen] = useState(false);
  const [isOpenStatusDrop, setIsOpenStatusDrop] = useState(false);
  const [statusChanged, setStatusChanged] = useState(false);
  const [status, setStatus] = useState("");
  const [modal, setModal] = useState(false);
  const [isPreviewOpen, setResourceModal] = useState(false);

  const toggleDelete = () => setModal(!modal);
  const togglePreview = () => setResourceModal(!isPreviewOpen);
  const toggle = () => setIsOpen(!isOpen);
  const toggleStatusDrop = () => setIsOpenStatusDrop(!isOpenStatusDrop);

  const toggleEditModal = () => {
    // CallCompany();
    setEditOpen(!isEditOpen);
  };
  const callDataFromDB = id => {
    resourceRef
      .doc(id)
      .get()
      .then(docs => {
        // console.log(docs);
        if (docs.exists) {
          setResource({ ...docs.data(), id: docs.id });
          setLoading(false);
          // console.log(docs.data());
        }
      })
      .catch(error => console.log(error));
  };

  // useEffect(() => {
  //   effect
  //   return () => {
  //     cleanup
  //   }
  // }, [props.currentCompany])

  useEffect(() => {
    if (props.resource) {
      setResource(props.resource);
      setLoading(false);
    } else {
      const { id } = props;
      // setLoading(true);
      callDataFromDB(id);
    }
    return () => {
      setResource(undefined);
      setLoading(false);
    };
  }, []);

  // console.log(resource);

  const onClickStatus = e => {
    const current = e.target.value;
    setStatus(current);
    if (current !== resource.status) {
      setStatusChanged(true);
    } else setStatusChanged(false);
  };

  const updateStatusHandler = () => {
    const newStatus = status.toLowerCase();
    setStatus("...");
    resourceRef
      .doc(resource.id)
      .update({ status: newStatus })
      .then(res => {
        setStatus(newStatus);
        if (props.resource && props.updateStatusInParent)
          props.updateStatusInParent(resource.id, newStatus);
        setStatusChanged(false);
      })
      .catch(error => {
        setStatusChanged(false);
        setStatus(resource.status);
        alert(error.message);
      });
  };

  const deleteHandler = () => {
    // console.log({ job });
    let currResource = { ...resource };
    resourceRef
      .doc(currResource.id)
      .delete()
      .then(() => {
        console.log({ currResource });

        setResource(undefined);
        setLoading(false);
        setModal(false);
        if (props.onResourceDeleteSuccess)
          props.onResourceDeleteSuccess(currResource.id);

        toast.success("Deleted Successfully!");
      })
      .catch(err => {
        alert("Error: " + err.message);
      });
  };

  const EditModal = () => {
    return (
      <Modal
        isOpen={isEditOpen}
        toggle={toggleEditModal}
        className="edit-job-modal"
      >
        <ModalHeader toggle={toggleEditModal}>Edit Resource</ModalHeader>
        <ModalBody>
          {/* {!props.currentCompany.name ? ( */}
          {/* <Spinner animation="border" variant="info" /> */}
          {/* ) : ( */}
          {/* <EditJob job={resource} /> */}
          {/* )} */}
        </ModalBody>
        <ModalFooter>
          {/* <Button
            color="primary"
            onClick={deleteHandler}
            size="sm"
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </Button>{" "} */}
          <Button color="secondary" onClick={toggleEditModal} size="sm">
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  };
  const ResourceModal = () => {
    return (
      <Modal
        isOpen={isPreviewOpen}
        toggle={togglePreview}
        className="edit-job-modal"
      >
        <ModalHeader toggle={togglePreview}>Edit Resource</ModalHeader>
        <ModalBody>
          <ResourcePreview resource={resource} />
        </ModalBody>
        <ModalFooter>
          {/* <Button
            color="primary"
            onClick={deleteHandler}
            size="sm"
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </Button>{" "} */}
          <Button color="secondary" onClick={togglePreview} size="sm">
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  const statusDropDown = () => (
    <ButtonDropdown isOpen={isOpenStatusDrop} toggle={toggleStatusDrop}>
      <Button id="caret" color="success" size="xs">
        {status || resource.status}
      </Button>
      <DropdownToggle caret color="success" />
      <DropdownMenu>
        <DropdownItem value="pending" onClick={onClickStatus}>
          Pending
        </DropdownItem>
        <DropdownItem value="published" onClick={onClickStatus}>
          Published
        </DropdownItem>
        <DropdownItem value="saved" onClick={onClickStatus}>
          Saved
        </DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>
  );
  console.log({ resource }, { user: props.user.admin });
  return (
    <React.Fragment>
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            {resource && (
              <>
                <Row>
                  <Col md={3}>
                    <div className="card__title">
                      {" "}
                      <h5 className="bold-text">Resource Details</h5>
                    </div>
                  </Col>
                  {props.user?.admin === true && (
                    <Col md={4}>
                      <Button color="danger" size="sm" onClick={toggleDelete}>
                        Delete Resource
                      </Button>{" "}
                      <Modal isOpen={modal} toggle={toggleDelete}>
                        <ModalHeader toggle={toggleDelete}>Delete</ModalHeader>
                        <ModalBody>
                          Are you sure you want to delete this resource ?
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="danger"
                            onClick={deleteHandler}
                            size="sm"
                            disabled={loading}
                          >
                            {loading ? "Deleting..." : "Delete"}
                          </Button>{" "}
                          <Button
                            color="secondary"
                            onClick={toggleDelete}
                            size="sm"
                          >
                            Cancel
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </Col>
                  )}
                  <Col md={4}>
                    {/* <a href={JOB_PATH(resource)} target="_blank"> */}
                    <Button color="primary" size="sm" onClick={togglePreview}>
                      Preview Resource
                    </Button>
                    {/* </a> */}
                  </Col>
                  {isPreviewOpen && ResourceModal()}
                  {/* <Col md={3}>
                    {props.user.dataEntry && resource.status !== "pending" ? (
                      ""
                    ) : (
                      <>
                        <Button
                          color="warning"
                          size="sm"
                          onClick={toggleEditModal}
                        >
                          Edit Resource
                        </Button>
                        <EditModal />
                      </>
                    )}
                  </Col> */}
                </Row>
                <Table>
                  <tbody>
                    <tr>
                      <th> Page Link: </th>
                      <td>
                        <a href={resource.pageLink} target="_blank">
                          {" "}
                          {resource.pageLink}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th> Page Title: </th>
                      <td>{resource.pageTitle}</td>
                    </tr>
                    <tr>
                      <th> Page Meta Description: </th>
                      <td>{resource.pageMetaDescription}</td>
                    </tr>
                    <tr>
                      <th> Title: </th>
                      <td>
                        <b> {resource.title} </b>
                      </td>
                    </tr>

                    <tr>
                      <th> Uploaded At: </th>
                      <td>
                        {resource.uploadedAt.toDate().toLocaleDateString()}
                      </td>
                    </tr>

                    <tr>
                      <th> Content: </th>
                      <td>
                        <div>
                          <Button color="primary" onClick={toggle} size="sm">
                            View Content
                          </Button>
                          <Collapse isOpen={isOpen}>
                            <Card>
                              <CardBody>
                                {ReactHTMLParser(resource.content)}
                              </CardBody>
                            </Card>
                          </Collapse>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th> Status: </th>
                      <td>
                        {!props.user?.admin === true ? (
                          <h4>
                            <Badge color="success"> {resource.status} </Badge>{" "}
                          </h4>
                        ) : (
                          <>
                            {statusDropDown()}{" "}
                            {statusChanged && (
                              <div>
                                <button
                                  onClick={updateStatusHandler}
                                  style={{
                                    background: "none",
                                    color: "#FFC107",
                                    border: "1px solid #FFC107",
                                    padding: ".3em .7em"
                                  }}
                                >
                                  Update
                                </button>{" "}
                                <button
                                  onClick={() => setStatusChanged(false)}
                                  style={{
                                    background: "none",
                                    color: "red",
                                    border: "1px solid red",
                                    padding: ".3em .7em"
                                  }}
                                >
                                  Cancel
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </>
            )}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  // currentCompany: state.companyReducer.currentCompany,
  user: state.authReducer.user
});

export default connect(mapStateToProps, null)(withRouter(JobDetails));
